import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout';
import DashboardLayout from '../layouts/DashboardLayout';
import AuthRoutes from '../modules/auth/AuthRoutes';
import DashboardRoutes from '../modules/dashboard/DashboardRoutes';
import InventoryRoutes from '../modules/inventory/InventoryRoutes';
import ConfigurationRoutes from '../modules/configuration/configurationRoutes';
import ProtectedRoute from '../accessRoute/ProtectedRoute';
import VendorRoutes from '../modules/vendor/vendorRoutes';
import ControlPanel from '../layouts/ControlPanel';
import ControlPanelRoutes from '../modules/controlPanel/ControlPanelRoutes';
import PartiesRoutes from '../modules/parties/PartiesRoutes';
import ShopManagementRoutes from '../modules/shopManagement/employeeManagement/employeeRoutes';
import EnquiryRoutes from '../modules/enquiry/EnquiryRoutes';
import ProductReturnRoutes from '../modules/productReturn/ProductReturnRoutes';
import AccountsRoutes from '../modules/accounts/AccountRoutes';
import AdminLayout from '../layouts/AdminLayout';
import ProfileRoutes from '../modules/admin/profile/ProfileRoutes';
import RoleRoutes from '../modules/admin/role/RoleRoutes';
import UserRoutes from '../modules/admin/users/UserRoutes';
import ReminderRoutes from '../modules/reminder/ReminderRoutes';

const AppRoutes = () => (
  <React.Suspense fallback={<div>Loading...</div>}>
    <Routes>
      {/* Auth Layout */}
      <Route element={<AuthLayout />}>
        {AuthRoutes}
      </Route>
      {/* Dashboard/Main Layout */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          {ProfileRoutes}
          {RoleRoutes}
          {UserRoutes}
        </Route>
        <Route element={<ControlPanel />}>
          {ControlPanelRoutes}
        </Route>
        <Route element={<DashboardLayout />}>
          {DashboardRoutes}
          {InventoryRoutes}
          {PartiesRoutes}
          {ReminderRoutes}
          {EnquiryRoutes}
          {ProductReturnRoutes}
          {VendorRoutes}
          {ShopManagementRoutes}
          {AccountsRoutes}
          {ConfigurationRoutes}
        </Route>
      </Route>
    </Routes>
  </React.Suspense>
);

export default AppRoutes;
